import React from 'react';
import ShippingInstrutionForm from "./shipping-instruction-form";
import {ShippingInstructionProvider} from "./shipping-instruction-context";

const ShippingInstructionFormContainer = () => {
    return (
        <ShippingInstructionProvider>
            <ShippingInstrutionForm />
        </ShippingInstructionProvider>
    );
};

export default ShippingInstructionFormContainer;
